import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import dynamic from "next/dynamic";
import InsuranceSuperSaverWrapper from "@components/layouts/insuranceSuperSaverWrapper";
import CategoryMainBanner from "@components/insurancesupersaver/categoryMainBanner";

const WhyUs = dynamic(() => import("@components/insurancesupersaver/whyUs"));
export default function InsuranceSuperSaverGenericRoutePage(): ReactElement {
    return (
        <InsuranceSuperSaverWrapper page="categoryPage">
            <CategoryMainBanner />
            <WhyUs />
        </InsuranceSuperSaverWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "genericRoute", {
        pageTitle:
            "Save Big on ${category.name}: Compare the Rates & Save Big Right Now",
    });
};
